import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Only import Bootstrap Icons (CSS framework no longer needed)
import "bootstrap-icons/font/bootstrap-icons.scss";

createApp(App).use(router).mount("#app");
